import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withNamespaces } from 'react-i18next'
import styled from 'styled-components'
import { withRouter } from 'react-router-dom'

import { setActiveProperty } from '../ducks/properties'
import { setActiveProperty as setChartActiveProperty } from '../ducks/chart'
import { fetchInteractionsPreview } from '../ducks/interactionsPreview'
import { fetchContract } from '../ducks/contracts'

import Select from '../components/Forms/Select'

const StyledLabelValue = styled.div`
  display: flex;
  align-items: center;
  height: 42px;

  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
  font-size: 11px;
  padding-top: 12px;
  background-color: #fff;
  border: 1px solid ${(props) => (props.error ? '#9f2121' : '#ececf0')};
  border-radius: 2px;
  color: #727272;
  padding: 0px 10px;

  margin-bottom: 12px;
`

class MobilePropertySelect extends Component {
  render() {
    const { t, properties, location } = this.props
    const { entities, selectedPropertyId, loading, error } = properties

    let propertyHandler
    if (location.pathname.indexOf('/dashboard/main') !== -1) {
      propertyHandler = this.handlePropertyMainChange
    } else if (location.pathname.indexOf('/dashboard/interaction') !== -1) {
      propertyHandler = this.handlePropertyInteractionsChange
    } else if (location.pathname.indexOf('/dashboard/contracts') !== -1) {
      propertyHandler = this.handlePropertyContractsChange
    } else {
      propertyHandler = () => {}
    }

    if (entities.length === 1) {
      return <StyledLabelValue>{entities[0].name}</StyledLabelValue>
    }

    const options = [
      {
        label: t('property:allProperties'),
        value: ''
      },
      ...entities.map(({ name, property_id }) => ({
        label: name,
        value: property_id
      }))
    ]

    return (
      <Select
        value={selectedPropertyId}
        disabled={loading || error}
        onChangeCallback={propertyHandler}
        options={options}
      />
    )
  }

  handlePropertyMainChange = (e) => {
    const { value } = e.target

    this.props.setActiveProperty(value, false)
    this.props.setChartActiveProperty(value)
    this.props.fetchInteractionsPreview()
  }

  handlePropertyInteractionsChange = (e) => {
    const { value } = e.target

    this.props.setActiveProperty(value)
  }

  handlePropertyContractsChange = (e) => {
    const { value } = e.target

    this.props.setActiveProperty(value, false)
    this.props.fetchContract(value)
  }
}

export default compose(
  connect(
    ({ states, properties }) => ({
      states,
      properties
    }),
    {
      setActiveProperty,
      setChartActiveProperty,
      fetchInteractionsPreview,
      fetchContract
    }
  ),
  withNamespaces(),
  withRouter
)(MobilePropertySelect)
